export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.21-0823.05",
  commitId: "8b429c03736f47dd1bcca0306207fceca3a861bc",
  commitTime: "2026-09-21T08:23:05.000Z",
});
